// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"style_boxContainer__198QB","textBoxContainer":"style_textBoxContainer__2XIEz"};